
export const MESSAGE_ALL_CHARACTER_LIMIT = 300;

export const JOB_REQUESTS_PER_PAGE = 10;

export const FILTERS_FINGERPRINT = 'JOBS_PAGE_FILTERS';

export const displayStates = {
  UPCOMING_JOB: 'UPCOMING_JOB',
  NEVER_CHECKED_IN_DONE: 'NEVER_CHECKED_IN_DONE',
  NEVER_CHECKED_IN_IN_PROGRESS: 'NEVER_CHECKED_IN_IN_PROGRESS',
  NEVER_CHECKED_OUT: 'NEVER_CHECKED_OUT',
  CURRENTLY_ACTIVE: 'CURRENTLY_ACTIVE',
  COMPLETED_EARLY: 'COMPLETED_EARLY',
  COMPLETED: 'COMPLETED',
  APPROVED: 'APPROVED',
  UNMAPPED: 'UNMAPPED',
  PAUSED: 'PAUSED',
};

export const trafficLightClasses = {
  GREEN: 'status-ok',
  YELLOW: 'status-notice',
  RED: 'status-warning',
  DONE: 'status-done',
  APPROVED: 'status-approved',
  NONE: 'status-none'
};

export const FILTER_FIELDS = {
  REQUESTOR_ID: 'requestorId',
  CATEGORY_ID: 'categoryId',
  DATE_RANGE: 'DATE_RANGE',
  SEARCH: 'search',
  STATUS: 'multipleStatus',
  SORT_ORDER: 'sortOrder',
  SHOW_ALL_WORKERS: 'showAllWorkers',
  ALERTS: 'alerts',
  ONLY_LTES: 'showOnlyLtes',
  VENUES: 'venueIds',
  JOB_REQUEST_IDS: 'jobRequestIds',
  SHIFTS: 'shiftIds',
  JOB_CODES: 'jobCodes',
  POSITIONS: 'positionIds'
};

export const FILTER_INPUT_KEYS = {
  ...FILTER_FIELDS,
  DATES: 'dates',
  OPEN_JOB_REQUEST_ROWS: 'OPEN_JOB_REQUEST_ROWS'
};

export const MESSAGE_MODAL = {
  JOB_REQUEST_ID: 'jobRequestId',
  JOB_ID: 'jobId',
  SHOW_MESSAGE_BY_JOB: 'showMessageByJob',
  SHOW_MESSAGE_BY_JOB_REQUEST: 'showMessageByJobRequest',
};

export const WANDA_VENUE_MODAL = {
  SHOW_WANDA_VENUES: 'showWandaVenues',
};

export const CANCEL_MODAL = {
  JOB_REQUEST: 'jobRequest',
  JOB: 'job',
  SHOW_CANCEL_BY_JOB: 'showCancelByJob',
  SHOW_CANCEL_BY_JOB_REQUEST: 'showCancelByJobRequest',
  SHOW_BULK_CANCEL_BY_JOB_REQUEST: 'showBulkCancelByJobRequest'
};

export const JOBS_SEGMENT = {
  MANAGE_JOBS_JOB_REQUEST_LIST_LOADER: 'MANAGE_JOBS_JOB_REQUEST_LIST_LOADER',
  MANAGE_JOBS_FILTERS_LOADER: 'MANAGE_JOBS_FILTERS_LOADER',
  MANAGE_JOBS_JOB_REQUEST_HEADER_OPEN: 'MANAGE_JOBS_JOB_REQUEST_HEADER_OPEN',
  CLICKED_FAVORITE_WORKER: 'CLICKED_FAVORITE_WORKER',
  CLICKED_INFO_BAR_TO_APPROVE: 'CLICKED_INFO_BAR_TO_APPROVE',
  CLICKED_BULK_APPROVE: 'CLICKED_BULK_APPROVE',
  CLICKED_SHOW_ALL_WORKERS: 'CLICKED_SHOW_ALL_WORKERS',
  CLICKED_INFO_BAR_IN_PROGRESS: 'CLICKED_INFO_BAR_IN_PROGRESS'
};
